import useSWR, { type SWRConfiguration } from 'swr';
import denApi from '@/lib/api/denApi';
import type { Group } from '@/types/group';

const fetcher = async (url: string) => await denApi.get<Group[], void>(url);

export function useListGroups(
  organizationId: string | null,
  swrOptions?: SWRConfiguration<Group[]>
) {
  // Org context comes from x-current-org-id cookie (not URL params)
  const url = organizationId ? `organization/groups` : null;
  const { data, error, isLoading, mutate } = useSWR<Group[]>(
    url,
    fetcher,
    { revalidateOnFocus: false, refreshInterval: 10000, ...(swrOptions ?? {}) } // Poll every 10 seconds for updates
  );

  return {
    groups: data ?? [],
    isLoading,
    error,
    refresh: mutate,
  };
}
